import { render } from "./editor.vue?vue&type=template&id=f22368da"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=f22368da&lang=css"
script.render = render

export default script